<script>
export default {
  name: 'StoreIcon',
}
</script>

<template>
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8 8.20204H13.2V10.602H10.8V8.20204Z"
      fill="currentColor"
    />
    <path
      d="M7.20001 10.602H4.80001V13.002H7.20001V10.602Z"
      fill="currentColor"
    />
    <path
      d="M4.80001 16.602V14.202H7.20001V16.602H4.80001Z"
      fill="currentColor"
    />
    <path
      d="M8.40001 16.602V14.202H10.8V16.602H8.40001Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.464 5.20204H16.728C17.1528 5.20204 17.496 5.54524 17.496 5.97004V18.834C17.496 19.2588 17.1528 19.602 16.728 19.602H1.36801C0.943206 19.602 0.600006 19.2588 0.600006 18.834V5.97004C0.600006 5.54524 0.943206 5.20204 1.36801 5.20204H4.63201V4.81804C4.63201 2.37964 6.60961 0.402039 9.04801 0.402039C11.4864 0.402039 13.464 2.37964 13.464 4.81804V5.20204ZM6.36001 4.81804V5.20204H11.736V4.81804C11.736 3.33244 10.5336 2.13004 9.04801 2.13004C7.56241 2.13004 6.36001 3.33244 6.36001 4.81804ZM9.60001 7.00204H14.4V11.802H9.60001V7.00204ZM12 17.802V13.002H8.40001V9.40204H3.60001V17.802H12Z"
      fill="currentColor"
    />
  </svg>

</template>

<style scoped lang="scss">

</style>
